import ReactNative from '../base_components';
import React from 'react';

const { StyleSheet, View, Image, Text, TouchableHighlight } = ReactNative;

const BUTTON_WIDTH = 973 * 0.025 + 'em';
const BUTTON_HEIGHT = 196 * 0.025 + 'em';

const styles = StyleSheet.create({
  wideButton: {
    width: BUTTON_WIDTH,
    height: BUTTON_HEIGHT,
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
  },
  inner: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: BUTTON_WIDTH,
    height: BUTTON_HEIGHT,
    alignSelf: 'stretch',
  },
  text: {
    marginTop: '0.4em',
    color: 'white',
    fontSize: '1.5em',
  },
});

const BUTTON_IMG = require('../../assets/img/wide_button.png');

type Props = {
  style?: any;
  text: string;
  onPress: () => void;
};

export default class WideButton extends React.PureComponent<Props> {
  render() {
    const { style, text, onPress } = this.props;

    return (
      <View style={[styles.wideButton, style]}>
        <Image style={styles.image} resizeMode='contain' source={BUTTON_IMG} />
        <TouchableHighlight
          style={styles.highlight}
          underlayColor='rgba(0,0,0,0.2)'
          onPress={onPress}
        >
          <View style={styles.inner}>
            <Text style={styles.text}>{text}</Text>
          </View>
        </TouchableHighlight>
      </View>
    );
  }
}
